var responsive = {
  conditionForDesktop: '(min-width: 996px)',
  conditionForTablet: '(min-width: 481px)',
  conditionForMobile: '(max-width: 480px)'
};
export { responsive as default };